
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]/collections/[slug]",
      function () {
        return require("private-next-pages/embedded-menu/[cName]/collections/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]/collections/[slug]"])
      });
    }
  